export const validateAccountRoute = 'validate-account';
